export const propsNames = Object.freeze({
  APP: 'Aplicacao',
  APP_VERSION: 'App Version',
  SESSION_ID: 'app_session_id',
  IS_PWA: 'is_pwa',
  USER_LOGGED_CPF: 'Cpf usuario logado',
  USER_LOGGED: 'Usuario logado',
  ORIGIN_PAGE: 'Pagina de Origem',

  MODALITY: 'Modalidade',
  CONSULTATION_SPECIALTY_CODE: 'Codigo da Especialidade da Consulta',
  SPECIALTY_DESCRIPTION: 'Descricao da Especialidade',
  SPECIALTY_HAS_ONLINE_SERVICE: 'Especialidade possui Atendimento Online',
  SPECIALTY_HAS_DIGITAL_CONSULTATION: 'Especialidade possui Consulta Digital',
  FLOW_TYPE: 'Fluxo de Atendimento',

  DOCTOR_NAME: 'Nome do Medico',
  DOCTOR_GENDER: 'Genero do Medico',
  DOCTOR_RDSL_CODE: 'Codigo RDSL do Medico',
  CONSULTATION_DOCTOR_CODE: 'Codigo do Medico da Consulta',

  CONSULTATION_SECTOR_CODE: 'Codigo do Setor da Unidade da Consulta',
  CONSULTATION_UNITY_CODE: 'Codigo da Unidade da Consulta',
  LOCAL_CODE: 'Codigo do Local',
  LOCAL_RDSL: 'Codigo RDSL do Local',
  LOCAL_TYPE: 'Tipo do Local',
  LOCAL_UF: 'UF',
  LOCAL_DESCRIPTION: 'Descricao do Local',
  UNITY_NAME: 'Nome da Unidade',
  GEOLOCATION_ACTIVED: 'Geolocalizacao Ativada',

  PATIENT_BIRTHDATE: 'Data de Nascimento do Paciente',
  PATIENT_GENDER: 'Genero do Paciente',

  HEALTH_CARRIER_NAME: 'Nome do Convenio',
  HEALTH_CARRIER_CODE: 'Codigo do Convenio',
  HEALTH_PLAN_CODE: 'Codigo do Plano',
  HEALTH_PLAN_NAME: 'Nome do Plano',
  PAYMENT_METHOD: 'Forma de pagamento',
  PAYMENT: 'Pagamento',
  HEALTH_CARRIER_METHOD_SELECT: 'Forma de selecao do convenio',
  HEALTH_PLAN_METHOD_SELECT: 'Forma de selecao do plano',

  BETTER_OFF: 'melhorOferta',
  SCHEDULE_CHOSEN_OFFER_DATE: 'Datas da Oferta de Agenda Escolhida',
  SCHEDULE_RETURNING: 'retornoAgenda',
  FIT: 'Encaixe',
  EXPANSION_REANSON: 'motivoExpansao',

  FALLBACK_RESERVE_HOUR: 'Fallback de Horario Reservado',
  FALLBACK_FILTER_WITHOUT_RESULT: 'Fallback de Filtro Sem Resultados',
  FALLBACK_LABEL: 'Rotulo do Fallback',
  FALLBACK_TYPE: 'Tipo de fallback',

  CLICK_FAVORITE_UNIT: 'Click Unidade Favorita',
  FAVORITE_UNITS_NAME: 'Nome das unidades Favorita',

  CLICK_LAST_SCHEDULE_UNITY: 'Click Ultimas Unidade Agendadas',
  UNITY_NAME_LAST_SCHEDULE: 'Nome das Ultimas Unidades Agendadas',

  CLICK_FAVORITE_DOCTOR: 'Click Profissionais Favoritos',
  FAVORITE_DOCTORS_NAME: 'Nome dos profissionais Favoritados',

  CLICK_LAST_SCHEDULE_DOCTOR: 'Click Ultimos Profissionais Agendados',
  DOCTOR_NAME_LAST_SCHEDULE: 'Nome dos Ultimos profissionais agendados',

  SOURCE_LIST: 'Fonte da Lista',
  SUGGESTION: 'Sugestao',
  LIST_DISPLAYED: 'Lista Exibida',

  DESCRIPTION: 'Descrição',
  STEP: 'Etapa',
  LABEL: 'Rotulo',
  TYPE: 'Tipo',
  ACTION: 'Acao',

  FILTER_GENDER: 'Generos Filtrados',
  FILTER_UNITS_NAMES: 'Nomes Unidades Filtradas',
  FILTER_UNITS_CODE: 'Codigos Unidades Filtradas',
  FILTER_SHIFTS: 'Turnos Filtrados',
  FILTER_DAYS_OF_WEEK: 'Dias da Semana Filtrados',
  FILTER_PREFERENCE_DAY: 'Data De Preferencia',
  FILTER_WITHOUT_FIT: 'Ocultar Horario de Encaixe',

  SEARCH_HOUR_UNITS_CODE: 'Codigos das Unidades Busca de Horarios',
  SEARCH_HOUR_UNITS_NAME: 'Nomes das Unidades Busca de Horarios',
  SEARCH_START_DATETIME: 'Data Hora Inicio da Busca',
  SEARCH_END_DATETIME: 'Data e Hora de Fim da Busca',

  SCHEDULE_OFFER_QUANTITY: 'Quantidade de Ofertas de Agenda',
  NEXT_SCHEDULE_DATETIME: 'Data Hora da Proxima Agenda Retornada',
  DAYS_UNTIL_NEXT_SCHEDULE: 'Distancia em Dias para Proxima Agenda',

  UNITS_CODES_WITH_COVERAGE: 'Codigos de Unidades com Cobertura',
  UNITS_NAMES_WITH_COVERAGE: 'Nomes das Unidades com Cobertura',
  UNITS_CODES_WITHOUT_COVERAGE: 'Codigos de Unidades sem Cobertura',
  UNITS_NAMES_WITHOUT_COVERAGE: 'Nomes das Unidades sem Cobertura',

  MODAL_FALLBACK_PRIVATE_SUGGESTION: 'modal_fb_sugestao_particular',
  BUTTON_PRIVATE: 'botao_particular',
  BUTTON_CLOSE: 'botao_fechar',

  HAS_COVERAGE: 'Possui Cobertura',

  SEARCH_TIME: 'Tempo de Busca',
  SUGGESTION_SCHEDULE: 'sugestaoAgenda',
  FIRST_SCHEDULE_LISTING: 'Primeira Listagem de Horario',
  LAST_SCHEDULE_LISTING: 'Ultima Listagem de Horario',
  TOTAL_SCHEDULE_LISTINGS: 'Total de Listagens de Horario',

  FIRST_OFFER: 'Primeira Oferta',
  FIRST_LISTED_DATE: 'Primeira Data na Agenda Apresentada',
  FIRST_LISTED_LOCATION: 'Primeiro Local na Agenda Apresentada',
  FIRST_SCHEDULE_FITTING: 'Primeira Agenda Encaixe',

  ALERT_REASON: 'Motivo do alert',

  GENERIC_ERROR_STATUS: 'Status do Erro Generico',
  GENERIC_ERROR_STATUS_TEXT: 'Status Texto do Erro Generico',
  GENERIC_ERROR_ORIGIN_PAGE: 'Pagina de Origem Erro Generico',
  GENERIC_ERROR_CODE: 'Codigo do Erro Generico',
  GENERIC_ERROR_NAME: 'Nome do Erro Generico',
  GENERIC_ERROR_MESSAGE: 'Mensagem de Erro Generica',
  GENERIC_ERROR_STACK: 'Stack do Erro Generico',
  GENERIC_ERROR_DATA: 'Dados do Erro Generico',
  GENERIC_ERROR_TYPE: 'Tipo do Erro Generico',
  BACKEND_ERROR_CODE: 'Codigo do Erro do Backend',
  BACKEND_MESSAGE_ERROR: 'Mensagem do Erro do Backend',

  SENTRY_EVENT_ID: 'ID do Evento no Sentry',
  MAX_RETRY_COUNT_SOCKET: 'Quantidade Retentativa socket',

  REQUISITION_CODE: 'Codigo Requisicao',
  REQUISITION_METHOD: 'Metodo da Requisicao',
  REQUISITION_URL: 'Endereco da Requisicao',
  REQUISITION_PARAMS: 'Parametros da Requisicao',

  EXTIMATED_SPEED: 'Velocidade da Conexão',
  ONLINE_STATUS: 'Status da Conexão',
  CONNECTION_TYPE: 'Tipo de Conexão',

  TIME_TO_OPEN_CONNECTION_SSE: 'Tempo de Abertura da Conexão SSE',
  TIME_TO_FAIL_CONNECTION_SSE: 'Tempo de Falha da Conexão SSE',

  MODAL_LOGIN_DUPLICATED_SCHEDULE: 'modal_login_duplicidade',
  LOGIN_BUTTON: 'botao_login',
  CLOSE_BUTTON: 'botao_fechar',
  MODAL_TOTAL_VISUALIZATION: 'total_modal',
  DUPLICATED_PAGE: 'pg_duplicidade',
  DUPLICATED_SCHEDULE_TOTAL_LIST: 'contagem_horarios',
  DUPLICATED_SCHEDULE_BUTTON_NEW_HOUR: 'botao_novo_horario',
  DUPLICATED_SCHEDULE_SELECTED_SLOT: 'horario_selecionar',
  DUPLICATED_SCHEDULE_SELECTED_COUNT: 'contagem_horarios_selecionados',
  DUPLICADO_SCHEDULE_SAME_DAY: 'pg_duplicidade_mesmo_dia',
  DUPLICATED_SCHEDULE_VISUALIZATION_PAGE: 'visualizou_pg_duplicidade',

  TIME_TO_OPEN_CONNECTION_SOCKET: 'Tempo de Abertura da Conexão Socket',
  TIME_TO_FAIL_CONNECTION_SOCKET: 'Tempo de Falha da Conexão Socket',

  PARAMS: 'parametros',
  CART_RECOVERY_ORIGIN: 'origem_recuperacao_carrinho',
  APP_NATIVE: 'App nativo'
})
